import { createBaseStore } from '@/stores/api/base.js';
import { useRefHistory } from '@vueuse/core';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSceneStore = defineStore('scene', () => {
  const currentScene = ref(null);
  const { history, undo, redo, clear, canRedo, canUndo, isTracking, pause, resume, commit } = useRefHistory(
    currentScene,
    { deep: true, flush: 'post' }
  );

  const {
    fetchItems: fetch,
    createDetails,
    storeItem: store,
    updateItem: update,
    destroyItem: destroy,
  } = createBaseStore('scene');

  const fetchWithHistory = async (itemId = null) => {
    const result = await fetch(itemId);
    if (itemId) {
      currentScene.value = result;
      clear();
      commit();
    }
    return result;
  };

  const commitHistory = (newScene) => {
    currentScene.value = newScene;
    if (isTracking.value) {
      commit();
      update(currentScene.value.uuid, currentScene.value);
    }
  };

  return {
    currentScene,
    fetch: fetchWithHistory,
    destroy,
    createDetails,
    update,
    store,
    history,
    undo,
    redo,
    canRedo,
    canUndo,
    commit: commitHistory,
    pause,
    resume,
  };
});
